(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-menu"]) return;
  try {
    
	function initMobileMenu() {
		const mobileMenu = document.querySelector('[data-mobile-menu]');
		const toggles = document.querySelectorAll('[data-mobile-menu-toggle]');
		const subnavs = document.querySelectorAll('[data-mobile-subnav]');
		const subnavToggles = document.querySelectorAll(
			'[data-mobile-subnav-toggle]',
		);

		if (!mobileMenu) return;

		toggles.forEach((toggle) =>
			toggle.addEventListener('click', () => {
				if (
					mobileMenu.getAttribute('data-mobile-menu-state') ===
					'closed'
				) {
					mobileMenu.setAttribute('data-mobile-menu-state', 'open');
					return;
				}

				subnavs.forEach((subnav) =>
					subnav.setAttribute('data-mobile-subnav-state', 'closed'),
				);
				mobileMenu.setAttribute('data-mobile-menu-state', 'closed');
			}),
		);

		subnavToggles.forEach((subnavToggle) =>
			subnavToggle.addEventListener('click', () => {
				const subnavId = subnavToggle.getAttribute(
					'data-mobile-subnav-toggle',
				);
				const subnav = document.querySelector(`#${subnavId}`);

				if (!subnav) return;

				if (
					subnav.getAttribute('data-mobile-subnav-state') === 'closed'
				) {
					subnav.setAttribute('data-mobile-subnav-state', 'open');
					return;
				}

				subnav.setAttribute('data-mobile-subnav-state', 'closed');
			}),
		);
	}

	document.addEventListener('DOMContentLoaded', () => {
		initMobileMenu();
	});

  } catch(e) { console.error(e); }
})();
})();
